'use strict';

const SectionPresenter = require('../presenters/section');

const BaseView = require('./base');

class SeatingSectionView extends BaseView {
  tagName() {
    return 'li';
  }

  initialize() {
    this.module = 'glive_booking_redesign';
    this.presenter = SectionPresenter;
    this.templateName = 'seatingSection';
    this.className = 'section-list-item';
  }

  events() {
    return { click: 'select' };
  }

  select(args, kill = false) {
    if (!kill) {
      $(args.toElement).trigger('click', true);
      this.trigger('select', this.model);
    }
  }
}

module.exports = SeatingSectionView;
